import React from "react";
import {FaHome, FaVideo, FaTv} from 'react-icons/fa'

export const navlinks =[
    {
        name:'Home',
        url:'/',
        icon: <FaHome />
    },
    {
        name:'Movies',
        url:'/movies',
        icon: <FaVideo />
    },
    {
        name:'TvShow',
        url:'/tvshows',
        icon: <FaTv />
    }

]